export const ACCEPTED_PARAMS = [
  "end",
  "start",
  "pois",
  "poisDistUnits",
  "timeBinSize",
  "sortField",
  "sortDirection",
  "aoiId",
  "precision",
  "language",
  "numberKeywords",
  "verbosity",
  "hashTagAggSize",
  "score",
  "sources",
  "feedIds",
  "forReport",
  "fields",
  "topics",
  "filterEventTypes",
  "filterEventTypes",
  "places",
  "radius",
  "gridType",
  "verbose",
  "locationType",
  "filterAoiId",
  "aois",
  "includeForecast",
  "forecastDate",
  "orderBy",
  "order",
  "offset",
  "limit",
  "severity",
  "impacts",
  "categories",
  "categoriesId",
  "sectors",
  "modifiedFrom",
  "modifiedTo",
  "dateFrom",
  "dateTo",
  "clusterId",
  "hotspotsOnly",
  "numDays",
  "onlyOutliers",
  "timestampProperties",
  "eventtimeStart",
  "countryCode",
  "cityCode",
  "waterCode",
  "options",
  "sentiments",
  "emotions",
  "assetId",
  "include",
  "polygon",
  "monitorRadiusUnit",
  "eventsStartDate",
  "eventsEndDate",
  "dateRange",
  "maxAge",
  "isOngoing",
  "isAccelerating",
  "isNew",
  "useSecondaryCountries",
  "similarity",
  "aoiIds",
  "keywordSearch",
  "sortBy",
  "model",
  "influencers",
  "influencees",
  "since",
];
